import React from "react";
import { Container, Row, Col } from "reactstrap";
import RelatedAlertsTable from "./AlertsEvents";
import IncidentDetails from "./IncidentDetails";
import IncidentSummaryCard from "./IncidentSummary";
import ResponseActions from "./ResponseActions";
import Timeline from "./Timeline";
import Timestamps from "./Timestamps";

const IncidentSummary = () => {
  document.title = "Incident Summary | Risknox";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Top Row - Incident Details and Summary */}
          <Row>
            <Col xl={8}>
              <IncidentSummaryCard />
            </Col>
            <Col xl={4}>
              <ResponseActions />
            </Col>
          </Row>

          {/* Middle Row - Timeline and Response Actions */}
          <Row>
            <Col lg={8}>
              <Timeline />
            </Col>
            <Col lg={4}>
              <IncidentDetails />
            </Col>
          </Row>

          {/* Bottom Row - Timestamps and Related Alerts */}
          <Row>
            <Col xl={8}>
              <RelatedAlertsTable />
            </Col>
             <Col xl={4}>
              <Timestamps />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IncidentSummary;